import React, { useContext, useState, useEffect } from "react";
import "./staff-header.scss";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import AddIcon from "../../../../assets/add_icon.png";
import AvatarIcon from "../../../../assets/Avatar.svg";
import AvatarBlue from "../../../../assets/AvatarBlue.svg";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import DoctorSelectModal from "../SelectDoctorModal";
import guideIcon from "../../../../assets/guide_icon.png";
import HomeIcon from "@material-ui/icons/Home";
import { doctorProfileFiles } from "../../../../Util/API Calls/APIList";
import SelectDoctorMobileView from "../SelectDoctorModal/SelectDoctorMobileView";
import useWindowSize from "../../../../Hooks/useWindowSize";
import SelectDoctorDesktopView from "../SelectDoctorModal/SelectDoctorDesktopView";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      "& .MuiAvatar-root": { backgroundColor: "#17BAE0" },
    },
  })
);

const StaffHeader = (props) => {
  const classes = useStyles();
  const { isPageHeading, headerText, joyrideToggle, homeClick } = props;
  const staff_context = useContext(DoctorContext);

  const [ddlist, setDDlist] = useState([]);
  const maxAvatars = 2;
  const [doctorselectModal, setDoctorSelectModal] = useState(false);
  const [showMobileView, setShowMobileView] = useState(false);
  const size = useWindowSize();

  useEffect(() => {
    if (staff_context?.selectedDoctor?.length > 0) {
      setDDlist(
        staff_context?.selectedDoctor?.filter(
          (doctor) => doctor.selected === true
        )
      );
    }
  }, [staff_context.selectedDoctor]);

  const handleModal = () => {
    if (size && size.width < 786) {
      setShowMobileView(true);
    } else {
      setDoctorSelectModal(true);
    }
  };
  function renderRemaining() {
    const remaining = ddlist.length - maxAvatars;
    let dd = "+" + remaining.toString();
    if (remaining < 1) return null;
    return (
      <Avatar
        sx={{
          bgcolor: "#17BAE0",
          border: "2px solid white",
          boxSizing: "content-box",
          cursor: "pointer",
        }}
        style={{ position: "relative", left: `${-16 * maxAvatars + 1}px` }}
        src="/static/images/avatar/1.jpg"
        alt={dd}
        // onClick={() => setDoctorSelectModal(true)}
        onClick={handleModal}
      >
        <p style={{ fontSize: "16px", margin: "0px", color: "white" }}>{dd}</p>
      </Avatar>
    );
  }

  const groupAvatar = () => {
    return (
      <>
        {ddlist.slice(0, maxAvatars).map((ed, i) => (
          <Avatar
            alt={ed.dr_first_name}
            sx={{
              bgcolor: `${
                ed.profile_picture_url
                  ? "white !important"
                  : "#17BAE0 !important"
              }`,
              border: "2px solid white",
              boxSizing: "content-box",
              cursor: "pointer",
            }}
            src={ed.profile_picture_url}
            style={{ position: "relative", left: `${-16 * i}px` }}
            // onClick={() => setDoctorSelectModal(true)}
            onClick={handleModal}
          />
        ))}
        {renderRemaining()}
        {/* <AvatarGroup max={3} className={`${classes.root}`} children>
          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg"></Avatar>
          <Avatar
            sx={{ bgcolor: "#17BAE0" }}
            alt="Travis Howard"
            src={AddIcon}
          />
          <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
          <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
          <Avatar alt="Trevor Henderson" src="/static/images/avatar/5.jpg" />
          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
        </AvatarGroup> */}
      </>
    );
  };
  return (
    <>
      <div className="staff-header-container d-flex w-100 justify-content-between">
        {/* justify-content-end */}
        <div>
          {!isPageHeading ? (
            <>
              <p className="welcome-text">Welcome Back,</p>
              <p className="header-text">
                {headerText ? headerText : "Staff Name"}
              </p>
            </>
          ) : (
            <>
              <p className="page-heading">
                {headerText ? headerText : "Page Heading"}
              </p>
            </>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "end" }}>
          {!isPageHeading && (
            <div className="d-sm-none d-lg-flex d-none mx-3 ">
              <div
                className={"d-flex align-items-center"}
                // style={{ borderRight: "1px solid #D6DAE5" }}
              >
                <div className={"mx-3"} style={{ width: "20px" }}>
                  {/* <img src={guideIcon} alt="home" /> */}
                  <HomeIcon
                    className="doctor-info-home-icon"
                    onClick={homeClick}
                  />
                </div>
              </div>
              <div
                className={"d-none align-items-center"} //d-flex
                style={{ borderRight: "1px solid #D6DAE5" }}
              >
                <div className={"mx-3"} style={{ width: "24px" }}>
                  <img src={guideIcon} alt="guid" onClick={joyrideToggle} />
                </div>
              </div>
            </div>
          )}
          {groupAvatar()}
          {/* <AvatarGroup>
            <Avatar
              className="ml-2"
              src={ddlist.length > 1 ? AvatarIcon : AvatarBlue}
              sx={{
                bgcolor: "white",
                boxSizing: "content-box",
                cursor: "pointer",
              }}
              // onClick={() => setDoctorSelectModal(true)}
              onClick={handleModal}
            />
          </AvatarGroup> */}
        </div>
      </div>

      {/* <DoctorSelectModal
        show={doctorselectModal}
        onHide={() => {
          setDoctorSelectModal(false);
        }}
      /> */}
      {doctorselectModal ? (
        <SelectDoctorDesktopView
          show={doctorselectModal}
          onHide={() => {
            setDoctorSelectModal(false);
          }}
        />
      ) : null}

      {showMobileView ? (
        <SelectDoctorMobileView
          show={showMobileView}
          onHide={() => setShowMobileView(false)}
        />
      ) : null}
    </>
  );
};

export default StaffHeader;
